/**
 * Helper functions for major field processing
 * Ensures consistency across all form components
 */

// Major field key constant
const MAJOR_FIELD_KEY = 'major';

/**
 * Cleans and normalizes major fields to match backend expectations
 * @param {*} majorValue - The major field value (array, string, or comma-separated string)
 * @returns {Array} - Cleaned array of majors (trimmed, filtered, deduped, sorted) - NO LIMIT
 */
export function cleanMajorValue(majorValue) {
  if (!majorValue) return [];

  let majors = [];

  if (Array.isArray(majorValue)) {
    majors = majorValue
      .map(s => (s || '').toString().trim())
      .filter(Boolean);
  } else if (typeof majorValue === 'string') {
    if (majorValue.indexOf(',') > -1) {
      majors = majorValue
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
    } else {
      const trimmed = majorValue.trim();
      if (trimmed) majors = [trimmed];
    }
  }

  // Deduplicate and sort alphabetically - UNLIMITED majors allowed
  return [...new Set(majors)]
    .sort((a, b) => a.localeCompare(b));
}

/**
 * Checks if a field object has a specific key using safe property access
 * @param {Object} obj - Object to check
 * @param {string} key - Key to look for
 * @returns {boolean} - True if key exists
 */
function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

/**
 * Mixin for Vue components that need major field cleaning
 * Provides consistent cleanMajorFields method
 */
export const MajorFieldsMixin = {
  methods: {
    cleanMajorFields() {
      
      const fieldsObj = this.dynamicFields || (this.ask && this.ask.dynamicFields);
      if (!fieldsObj) return;

      if (!hasOwnProperty(fieldsObj, MAJOR_FIELD_KEY)) return;

      const cleanedMajors = cleanMajorValue(fieldsObj[MAJOR_FIELD_KEY]);

      if (cleanedMajors.length > 0) {
        this.$set(fieldsObj, MAJOR_FIELD_KEY, cleanedMajors);
      } else {
        this.$delete(fieldsObj, MAJOR_FIELD_KEY);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/helpers/majorsHelper.js